<script setup lang="ts">
/* Types */
import { DateTimeChoices } from '@/store/basket/basket.types'
type Props = {
  dateChoices: DateTimeChoices[]
  timeChoices: DateTimeChoices[]
  errorMessage?: string
}
defineProps<Props>()

const emit = defineEmits(['get-time-choices', 'update-time'])

const selectedDate = defineModel<string>('selectedDate')
const selectedTime = defineModel<string>('selectedTime')
</script>

<template>
  <div class="on-time-selects">
    <the-dropdown
      v-model="selectedDate"
      item-title="text"
      item-value="value"
      variant="secondary"
      width="auto"
      :items="dateChoices"
      @update:model-value="emit('get-time-choices')"
    />

    <the-dropdown
      v-model="selectedTime"
      :disabled="!!errorMessage"
      item-title="text"
      item-value="value"
      variant="secondary"
      width="auto"
      :items="timeChoices"
      @update:model-value="emit('update-time')"
    />
  </div>
</template>

<style scoped lang="scss">
.on-time-selects {
  display: grid;
  grid-template-columns: 180px 90px;
  gap: 0 10px;
  margin-bottom: 30px;

  @include media('>phone') {
    grid-template-columns: 185px 110px;
    gap: 0 15px;
  }
}
</style>
